// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4664) return "static/chunks/4664-bc96474c70a5c5a0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"608":"f37dada0bdc64201","1997":"44d82c431bfa12ba","6841":"a918f8819f885b32"}[chunkId] + ".js";
};